import store from '@/store'
import { computed, ref, watch } from '@vue/composition-api'

// Notification
import { useToast } from 'vue-toastification/composition'
import { currency } from '@core/utils/filter'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getUserData } from '@/auth/utils'

export default function useInvoicesList() {
  // Use toast
  const toast = useToast()

  const refPedidosListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'id', label: '#', sortable: true },
    { key: 'client', sortable: true, label: 'Cliente' },
    { key: 'info_order', sortable: true },
    { key: 'data_venda', sortable: true, label: 'Data da venda' },
    {
      key: 'valor_total_pedido', sortable: true, label: 'Comissão',
    },
    { key: 'condicao_pagamento', sortable: true, label: 'Metodo de pagamento' },
    { key: 'status', sortable: true, label: 'Status' },
    // { key: 'data_inclusao', sortable: true, label: 'Data Criação' },
    { key: 'actions', label: 'Ações' },
  ]
  const perPage = ref(10)
  const totalInvoices = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)
  const metodoPaymentFilter = ref(null)
  const integracaoFilter = ref(null)
  const dataInicioFilter = ref(null)
  const dataFimFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refPedidosListTable.value ? refPedidosListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalInvoices.value,
    }
  })

  const refetchData = () => {
    console.log('refetchData chamado')
    refPedidosListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter, metodoPaymentFilter, integracaoFilter, dataInicioFilter, dataFimFilter], () => {
    console.log('Watch acionado - Filtros alterados:', {
      dataInicio: dataInicioFilter.value,
      dataFim: dataFimFilter.value,
      status: statusFilter.value,
      metodoPayment: metodoPaymentFilter.value,
    })
    refetchData()
  })

  const findAll = (ctx, callback) => {
    const params = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      status: statusFilter.value,
      metodoPayment: metodoPaymentFilter.value,
      dataInicio: dataInicioFilter.value,
      dataFim: dataFimFilter.value,
    }
    
    console.log('Parâmetros enviados:', params)
    
    store
      .dispatch('appClientPedidos/findAll', params)
      .then(response => {
        const { data, total } = response.data

        callback(data)
        console.log('Pedidos', data.data)
        // store.commit('appClientPedidos/SET_PEDIDOS', data)
        perPage.value = response.data.perPage
        currentPage.value = response.data.page
        totalInvoices.value = total
      })
      .catch(e => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error ao carregar os pedidos',
            text: e,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const sendPedidoBlingNfe = async idPedido => {
    await sendNfeBling(idPedido)
  }
  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*
  // enum('Paid', 'Canceled', 'Failed', 'Pending')
  const resolverOrderStatusIconAndVariant = status => {
    if (status === 'Paid') return { variant: 'success', icon: 'CheckCircleIcon' }
    if (status === 'Completed') return { variant: 'primary', icon: 'PackageIcon' }
    if (status === 'Pending') return { variant: 'warning', icon: 'ArrowDownCircleIcon' }
    if (status === 'Waiting_Payment') return { variant: 'warning', icon: 'ArrowDownCircleIcon' }
    if (status === 'Canceled') return { variant: 'danger', icon: 'InfoIcon' }
    if (status === 'Failed') return { variant: 'info', icon: 'InfoIcon' }
    if (status === 'Expired') return { variant: 'danger', icon: 'XIcon' }
    return { variant: 'primary', icon: 'XIcon' }
  }

  const resolverStatusVariante = status => {
    if (status === 'Canceled') return 'danger'
    if (status === 'Failed') return 'info'
    if (status === 'Waiting_Payment') return 'warning'
    if (status === 'Paid') return 'success'
    if (status === 'Completed') return 'primary'
    if (status === 'Expired') return 'danger'
    return 'warning'
  }

  const resolveStatusText = status => {
    if (status === 'Canceled') return 'Cancelado'
    if (status === 'Failed') return 'Falhou'
    if (status === 'Waiting_Payment') return 'Aguardando pagamento'
    if (status === 'Paid') return 'Pago'
    if (status === 'Completed') return 'Concluído'
    if (status === 'Expired') return 'Expirado'
    return 'Pendente'
  }

  const resolveCondicaoPagamento = status => {
    switch (status) {
      case 1:
        return 'Cartão (À vista)'
      case 2:
        return 'A prazo'
      case 3:
        return 'Pix'
      case 4:
        return 'Cartão (Parcelado)'
      case 5:
        return 'Boleto'
      case 6:
        return 'Cartão'
      case 7:
        return 'Cheque'
      default:
        return 'Não informado'
    }
  }

  const resolveCondicaoPagamentoVariant = status => {
    switch (status) {
      case 1:
        return 'primary' // Cartão (À vista)
      case 2:
        return 'warning' // A prazo
      case 3:
        return 'success' // Pix
      case 4:
        return 'info' // Cartão (Parcelado)
      case 5:
        return 'secondary' // Boleto
      case 6:
        return 'danger' // Cartão
      case 7:
        return 'dark' // Cheque
      default:
        return 'danger'
    }
  }

  const resolveAprovado = status => {
    if (status === 1) return 'Aprovado'
    if (status === 0) return 'Não aprovado'
    return 'Não aprovado'
  }

  const resolveAprovadoVariant = status => {
    if (status === 1) return 'success'
    if (status === 0) return 'danger'
    return 'danger'
  }

  const statusOptions = [
    { value: null, text: 'Todos' },
    { value: 'pending', text: 'Pendente' },
    { value: 'paid', text: 'Pago' },
    { value: 'completed', text: 'Concluído' },
    { value: 'canceled', text: 'Cancelado' },
    // { value: 'Failed', text: 'Falha' },
    // { value: 'Waiting_Payment', text: 'Aguardando Pagamento' },
    // { value: 'Expired', text: 'Expirado' },
  ]

  const metodoPaymentOptions = [
    { value: null, text: 'Todos' },
    { value: 'A_VISTA', text: 'Cartão de crédito' },
    { value: 'PIX', text: 'PIX' },
    { value: 'BOLETO', text: 'Boleto' },
  ]

  const integracaoOptions = [
    { value: null, text: 'Todos' },
    { value: 'pagarMe', text: 'PagarMe' },
    { value: 'pagSeguro', text: 'PagSeguro' },
  ]

  return {
    findAll,
    tableColumns,
    perPage,
    currentPage,
    totalInvoices,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refPedidosListTable,
    statusOptions,
    metodoPaymentFilter,
    metodoPaymentOptions,
    integracaoFilter,
    integracaoOptions,

    statusFilter,
    dataInicioFilter,
    dataFimFilter,
    // Status
    resolverOrderStatusIconAndVariant,
    resolverStatusVariante,
    resolveStatusText,
    // Condicao de pagamento
    resolveCondicaoPagamento,
    resolveCondicaoPagamentoVariant,
    // Aprovado
    resolveAprovado,
    resolveAprovadoVariant,
    sendPedidoBlingNfe,
    refetchData,
  }
}
